import { render } from "./App.vue?vue&type=template&id=4d9f30a2"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=4d9f30a2&lang=css"

import exportComponent from "D:\\project\\weetgo\\doo3dexamples\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__